import netsChatChangeParticipantsAutofill from './nets-chat-change-participants-autofill';

export default angular
  .module('app.chat-change-participants-autofill', [])
  .component('netsChatChangeParticipantsAutofill', netsChatChangeParticipantsAutofill);
